export default __webpack_public_path__ + "static/media/circle-8.7fbb81a0.svg";